import { render, staticRenderFns } from "./EditarApresentante.vue?vue&type=template&id=42570cdb&scoped=true"
import script from "./EditarApresentante.vue?vue&type=script&lang=js"
export * from "./EditarApresentante.vue?vue&type=script&lang=js"
import style0 from "./EditarApresentante.vue?vue&type=style&index=0&id=42570cdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42570cdb",
  null
  
)

export default component.exports